module.exports = __webpack_public_path__ + "img/logo.ee4e4c41.png";